export const TeamNames: { [key: string]: string } = {
  BAR: 'Philadelphia Barrage',
  BAY: 'Chesapeake Bayhawks',
  BLZ: 'Atlanta Blaze',
  CAN: 'Boston Cannons',
  CAM: 'Chicago Machine',
  DRG: 'San Francisco Dragons',
  HAM: 'Connecticut Hammerheads',
  HND: 'Charlotte Hounds',
  LAU: 'Florida Launch',
  MAC: 'Ohio Machine',
  NAT: 'Hamilton Nationals',
  NJP: 'New Jersey Pride',
  NYL: 'New York Lizards',
  OUT: 'Denver Outlaws',
  RAT: 'Rochester Rattlers',
  RIP: 'Los Angeles Riptide',
  ARC: 'Archers',
  ATL: 'Atlas',
  CHA: 'Chaos',
  CHR: 'Chrome',
  RED: 'Redwoods',
  WAT: 'Waterdogs',
  WHP: 'Whipsnakes',
  ZPP: 'Player Pool',
}

export const shortTeamNames = {
  CAN: 'Cannons',
  ARC: 'Archers',
  ATL: 'Atlas',
  CHA: 'Chaos',
  CHR: 'Chrome',
  RED: 'Redwoods',
  WAT: 'Waterdogs',
  WHP: 'Whipsnakes',
  ZPP: 'Player Pool',
}

export const teamIdList = ['CAN', 'ARC', 'ATL', 'CHA', 'CHR', 'RED', 'WAT', 'WHP']

export function convertTeamId(teamId: string, year: number) {
  let teamName = TeamNames[teamId]
  if (teamId === 'RAT' && ((year > 2008 && year < 2011) || year > 2017)) {
    teamName = 'Dallas Rattlers'
  } else if (teamId === 'NAT' && year > 2008 && year < 2011) {
    teamName = 'Toronto Nationals'
  } else if (teamId === 'NYL' && year < 2013) {
    teamName = 'Long Island Lizards'
  } else if (teamId === 'BAY') {
    if (year < 2007) {
      teamName = 'Baltimore Bayhawks'
    } else if (year > 2006 && year < 2010) {
      teamName = 'Washington Bayhawks'
    }
  } else if (teamId === 'BAR' && year < 2004) {
    teamName = 'Bridgeport Barrage'
  } else if (teamId === 'CAN' && year >= 2021) {
    teamName = 'Cannons'
  }
  return teamName
}
